import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { PhoneInput } from "react-international-phone";
import { useForm, Controller } from "react-hook-form";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { authActions, UserActions } from "../../../../../redux/actions";
import {
  appendMandatorySignAndTimezoneText,
  serverFormatToDateObject,
  serverFormatToDateString,
} from "../../../../../system";
import {
  roles,
  getNameById,
  countryConstants,
  translationConstants,
  fieldLengthConstants,
  Directions,
  preferedLanguagesContants,
  timezoneConstants,
  bloodTypes,
} from "../../../../../constants";
import ReactDatePickerWrapper from "../../../../../shared/components/ReactDatePickerWrapper/ReactDatePickerWrapper";
import AdminCertificateView from "../../../../../shared/components/ApproveRejectCertificate/AdminCertificateView";

const ViewUserApproval = (props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const countries = useSelector((state) => state.LoginReducer.countries);
  const userDataObject = useSelector(
    (state) => state.UserReducer.approvalUserData
  );

  const cities = useSelector((state) => state.LoginReducer.cities);
  const userData = userDataObject.userInfo;
  const userDocuments = userDataObject.documents;
  const userCertificates = userDataObject.certificates;
  const [startDate, setStartDate] = useState(new Date("1/1/1990"));
  const [key, setKey] = useState("");

  const {
    setValue,
    register,
    control,
    formState: { errors },
  } = useForm();

  const approvedDocument = (document) => {
    const Status = {
      status: 0,
      documentTypeId: document.documentTypeId,
    };
    const DocumentStatus = {
      userId: userData.id,
      userEmail: userData.email,
      documentStatuses: [Status],
    };
    dispatch(UserActions.approvedDocuments(DocumentStatus, props.gridState));
  };

  useEffect(() => {
    if (userData?.countryId) {
      if (cities.length <= 0) {
        dispatch(authActions.fetchCities(userData?.countryId));
      }
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setValue("firstName", userData?.englishFirstName);
    setValue("lastName", userData?.englishLastName);
    setValue("firstNameArabic", userData?.arabicFirstName);
    setValue("lastNameArabic", userData?.arabicLastName);
    setValue("email", userData?.email);
    setValue("verifiedDoc", userData?.arabicFirstName);
    setValue("phoneNumber", userData?.phoneNumber);
    if (userData?.dobString) {
      const dateObject = serverFormatToDateObject(userData.dobString);
      setStartDate(dateObject);
      setValue("dateOfBirth", dateObject, {
        shouldValidate: true,
      });
    }
    setValue("expiryData", userData?.phoneNumber);
    setValue("gender", userData?.gender);
    setValue("nationality", userData?.nationality);
    setValue("countryresidence", userData?.countryId);
    setValue("cityresidence", userData?.cityId);
    setValue("preferredLangauge", userData?.preferredLangauge);
    setValue("bloodGroup", userData?.bloodGroup);
    setKey(userCertificates?.length > 0 ? "Certificates" : "Documents");

    // eslint-disable-next-line
  }, [countries, userDataObject, cities]);

  const HandleModal = (event, fileDetails) => {
    if (event?.target?.name === "rejected") {
      dispatch(
        UserActions.OpenAppRejModal({
          modalStatus: true,
          eventType: "rejected",
          userEmail: userData.email,
          userID: userData.id,
          fileDetails: fileDetails,
        })
      );
    } else if (event?.target?.name === "approved") {
      dispatch(
        UserActions.OpenAppRejModal({
          modalStatus: true,
          eventType: "approved",
          userEmail: userData.email,
          userID: userData.id,
          fileDetails: fileDetails,
        })
      );
    }
    //If General user certificates are rejected
    if (event === "rejected") {
      dispatch(
        UserActions.OpenAppRejModal({
          modalStatus: true,
          eventType: "rejected",
          userEmail: userData.email,
          userID: userData.id,
          fileDetails: fileDetails,
          isGeneralUser: true,
        })
      );
    }
  };

  return (
    <div className="modal-tab-container">
      <div className="ViewHeader">
        <p className="viewUserPara">{t(translationConstants.userRequest)}</p>
      </div>
      <p className="horizentalLine" />

      <Tabs
        id="controlled-tab-example"
        activeKey={key}
        onSelect={(k) => setKey(k)}
        className="nav-links m-0 mt-4 "
      >
        <Tab
          className="m-0 mt-4 "
          eventKey="General"
          title={t(translationConstants.general)}
        >
          <Form noValidate className="ViewUserContent ViewUserContentForm">
            {/* firstLastName */}
            <div className="inputRow">
              <Form.Group className="form-group-register">
                <Form.Label className="Form-labels">
                  {t(translationConstants.firstName)}:
                </Form.Label>
                <Form.Control
                  {...register("firstName", {})}
                  id="firstName"
                  disabled={true}
                  type="text"
                  maxLength={fieldLengthConstants.TEXT_FIELD_LENGTH}
                />
                {errors.firstName && (
                  <p className="errorText">{errors.firstName.message}</p>
                )}
              </Form.Group>

              <Form.Group className="form-group-register">
                <Form.Label className="Form-labels">
                  {t(translationConstants.lastName)}:
                </Form.Label>
                <Form.Control
                  {...register("lastName", {})}
                  id="lastName"
                  disabled={true}
                  type="text"
                  maxLength={fieldLengthConstants.TEXT_FIELD_LENGTH}
                />
                {errors.lastName && (
                  <p className="errorText">{errors.lastName.message}</p>
                )}
              </Form.Group>
            </div>

            {/* arabiclastName */}
            <div className="inputRow">
              <Form.Group className="form-group-register">
                <Form.Label className="Form-labels">
                  {t(translationConstants.firstNameArabic)}:{" "}
                  <span>{t(translationConstants.optional)}</span>{" "}
                </Form.Label>
                <Form.Control
                  {...register("firstNameArabic", {})}
                  id="firstNameArabic"
                  type="text"
                  maxLength={fieldLengthConstants.TEXT_FIELD_LENGTH}
                  disabled={true}
                  style={{ direction: Directions.rtl }}
                />
                {errors.firstNameArabic && (
                  <p className="errorText">{errors.firstNameArabic.message}</p>
                )}
              </Form.Group>

              <Form.Group className="form-group-register">
                <Form.Label className="Form-labels">
                  {t(translationConstants.lastNameArabic)}:{" "}
                  <span>{t(translationConstants.optional)}</span>
                </Form.Label>
                <Form.Control
                  {...register("lastNameArabic", {})}
                  id="lastNameArabic"
                  disabled={true}
                  type="text"
                  maxLength={fieldLengthConstants.TEXT_FIELD_LENGTH}
                  style={{ direction: Directions.rtl }}
                />
                {errors.lastNameArabic && (
                  <p className="errorText">{errors.lastNameArabic.message}</p>
                )}
              </Form.Group>
            </div>

            {/* emailPhoneNumber */}
            <div className="inputRow">
              <Form.Group className="form-group-register">
                <Form.Label className="Form-labels">
                  {t(translationConstants.email)}
                </Form.Label>
                <Form.Control
                  {...register("email", {})}
                  id="email"
                  disabled={true}
                  type="email"
                  maxLength={fieldLengthConstants.EMAIL_FIELD_LENGTH}
                />
                {errors.email && (
                  <p className="errorText">{errors.email.message}</p>
                )}
              </Form.Group>

              <Form.Group className="form-phone-group-max-width">
                <Form.Label className="Form-labels">
                  {t(translationConstants.phoneNumber)}:
                </Form.Label>

                <Controller
                  name="phoneNumber"
                  control={control}
                  render={({ field: { value } }) => (
                    <PhoneInput
                      defaultCountry="sa"
                      value={value}
                      disabled={true}
                      maxLength={fieldLengthConstants.PHONENUMBER_FIELD_LENGTH}
                    />
                  )}
                />
                {errors.phoneNumber && (
                  <p className="errorText">{errors.phoneNumber.message}</p>
                )}
              </Form.Group>
            </div>

            <div className="inputRow">
              <Form.Group className="form-group-register">
                <Form.Label className="Form-labels">
                  {appendMandatorySignAndTimezoneText(
                    t(translationConstants.dateOfBirth),
                    t,
                    false
                  )}
                </Form.Label>
                <Controller
                  name="dateOfBirth"
                  control={control}
                  rules={{
                    required: t(translationConstants.dateOfBirthRequired),
                  }}
                  render={({ field }) => (
                    <div className="react-datepicker-wrapper-parent disabled-bg">
                      <ReactDatePickerWrapper
                        disabled={true}
                        selected={startDate}
                      />
                    </div>
                  )}
                />
                {errors.dateOfBirth && (
                  <p className="errorText">{errors.dateOfBirth.message}</p>
                )}
              </Form.Group>

              <Form.Group className="form-group-register">
                <Form.Label className="Form-labels">
                  {t(translationConstants.gender)}:
                </Form.Label>
                <Form.Select
                  disabled={true}
                  {...register("gender", {
                    required: t(translationConstants.genderSelectionRequired),
                  })}
                  aria-label="Default select example"
                >
                  <option value="">
                    {t(translationConstants.selectGender)}
                  </option>
                  <option value={0}>{t(translationConstants.male)}</option>
                  <option value={1}>{t(translationConstants.female)}</option>
                </Form.Select>
                {errors.gender && (
                  <p className="errorText">{errors.gender.message}</p>
                )}
              </Form.Group>
            </div>

            <div className="inputRow">
              <Form.Group className="form-group-register">
                <Form.Label className="Form-labels">
                  {t(translationConstants.nationality)}:
                </Form.Label>
                <Form.Control
                  {...register("nationality", {})}
                  id="nationality"
                  disabled={true}
                  type="text"
                />
                {errors.nationality && (
                  <p className="errorText">{errors.nationality.message}</p>
                )}
              </Form.Group>
              <Form.Group className="form-group-register">
                <Form.Label className="Form-labels">
                  {t(translationConstants.countryOfResidence)}:
                </Form.Label>
                <Form.Select
                  {...register("countryresidence", {
                    required: t(translationConstants.countryResidenceRequired),
                  })}
                  disabled={true}
                  aria-label="Default select example"
                >
                  <option value="">
                    {t(translationConstants.selectresidence)}
                  </option>
                  {countries?.data?.map((residence) => (
                    <option key={residence.id} value={residence.id}>
                      {residence.name}
                    </option>
                  ))}
                </Form.Select>

                {errors.countryresidence && (
                  <p className="errorText">{errors.countryresidence.message}</p>
                )}
              </Form.Group>

              {+userData?.countryId === +countryConstants.SAUDIA_ARABIA && (
                <Form.Group className="form-group-register">
                  <Form.Label
                    htmlFor="cityResidenceSelect"
                    className="Form-labels"
                  >
                    {" "}
                    {t(translationConstants.cityofresidence)}
                  </Form.Label>
                  <Form.Select
                    id="cityResidenceSelect"
                    {...register("cityresidence", {
                      required: t(translationConstants.cityResidenceRequired),
                    })}
                    disabled={true}
                    aria-label="Default select example"
                  >
                    <option value="">
                      {t(translationConstants.selectcity)}
                    </option>
                    {cities?.map((city) => (
                      <option key={city.id} value={city.id}>
                        {city.name}
                      </option>
                    ))}
                  </Form.Select>
                  {errors.cityresidence && (
                    <p className="errorText">{errors.cityresidence.message}</p>
                  )}
                </Form.Group>
              )}
              <Form.Group className="form-group-register">
                <Form.Label
                  htmlFor="preferredLanguageSelect"
                  className="Form-labels"
                >
                  {t(translationConstants.PREFERRED_LANGUAGE)}:
                </Form.Label>
                <Form.Select
                  id="preferredLanguageSelect"
                  {...register("preferredLangauge", {
                    required: t(
                      translationConstants.SELECT_PREFERRED_LANGUAGE_Required
                    ),
                  })}
                  disabled={true}
                  onChange={(e) => {
                    const value = e.target.value;
                    setValue("preferredLangauge", value, {
                      shouldValidate: true,
                    });
                    e.stopPropagation();
                  }}
                  aria-label="Default select example"
                >
                  <option value="">
                    {t(translationConstants.SELECT_PREFERRED_LANGUAGE)}
                  </option>
                  <option value="0">{preferedLanguagesContants.Arabic}</option>
                  <option value="1">{preferedLanguagesContants.English}</option>
                </Form.Select>
                {errors.preferredLangauge && (
                  <p className="errorText">
                    {errors.preferredLangauge.message}
                  </p>
                )}
              </Form.Group>
              <Form.Group className="form-group-register">
                <Form.Label className="Form-labels">
                  {t(translationConstants.BLOOD_GROUP)}:
                </Form.Label>
                <Form.Select
                  className="custom-select-icon"
                  {...register("bloodGroup", {
                    required: t(translationConstants.BLOOD_GROUP_REQUIRED),
                  })}
                  disabled={true}
                  onChange={(e) => {
                    const value = e.target.value;
                    setValue("bloodGroup", value, {
                      shouldValidate: true,
                    });
                    e.stopPropagation();
                  }}
                >
                  <option value="">
                    {t(translationConstants.SELECT_BLOOD_GROUP)}
                  </option>
                  {Object.values(bloodTypes).map((type) => (
                    <option key={type} value={type}>
                      {type}
                    </option>
                  ))}
                </Form.Select>
                {errors.bloodGroup && (
                  <p className="errorText">{errors.bloodGroup.message}</p>
                )}
              </Form.Group>
            </div>
          </Form>
        </Tab>

        {userDocuments?.length > 0 && (
          // documents
          <Tab eventKey="Documents" title={t(translationConstants.documents)}>
            <div className="inputRow">
              <Form.Group className="form-group">
                <Form.Label className="Form-labels d-flex justify-content-between">
                  {t(translationConstants.verifiedDoc)}:
                  <span>
                    <svg
                      onClick={() => approvedDocument(userDocuments[0])}
                      style={{ marginLeft: 3 }}
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 33 33"
                      fill="none"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M16.1378 30.9309C7.96782 30.9309 1.34473 24.3078 1.34473 16.1378C1.34473 7.96782 7.96782 1.34473 16.1378 1.34473C24.3078 1.34473 30.9309 7.96782 30.9309 16.1378C30.9309 24.3078 24.3078 30.9309 16.1378 30.9309ZM16.1378 28.2413C22.8224 28.2413 28.2413 22.8224 28.2413 16.1378C28.2413 9.45328 22.8224 4.03438 16.1378 4.03438C9.45328 4.03438 4.03438 9.45328 4.03438 16.1378C4.03438 22.8224 9.45328 28.2413 16.1378 28.2413ZM20.5662 11.1524L13.4482 18.2704L10.3646 15.1869L8.46276 17.0888L13.4482 22.0742L22.4681 13.0543L20.5662 11.1524Z"
                        fill="#588930"
                      />
                    </svg>

                    <svg
                      //onClick={() => cancelDocument(userDocuments[0])}
                      onClick={(e) => {
                        HandleModal("rejected", userDocuments[0]);
                        props.setShow(false);
                      }}
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 33 33"
                      fill="none"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M16.862 30.9309C8.69195 30.9309 2.06885 24.3078 2.06885 16.1378C2.06885 7.96782 8.69195 1.34473 16.862 1.34473C25.032 1.34473 31.6551 7.96782 31.6551 16.1378C31.6551 24.3078 25.032 30.9309 16.862 30.9309ZM16.862 28.2413C23.5465 28.2413 28.9654 22.8224 28.9654 16.1378C28.9654 9.45328 23.5465 4.03438 16.862 4.03438C10.1774 4.03438 4.7585 9.45328 4.7585 16.1378C4.7585 22.8224 10.1774 28.2413 16.862 28.2413ZM12.4336 22.4681L16.862 18.0397L21.2903 22.4681L23.1922 20.5662L18.7638 16.1378L23.1922 11.7095L21.2903 9.80758L16.862 14.236L12.4336 9.80758L10.5317 11.7095L14.9601 16.1378L10.5317 20.5662L12.4336 22.4681Z"
                        fill="#FF0000"
                      />
                    </svg>
                  </span>
                </Form.Label>
                {userDocuments &&
                  userDocuments.map((document) => {
                    return document.files.map((file) => {
                      return (
                        <div
                          key={file.documentId}
                          className="fileNameDisplay expiryDateDisplay mt-2"
                        >
                          <span>{t(getNameById(document.documentTypeId))}</span>
                          <div className="iconsDivUserDocument">
                            <svg
                              onClick={() => window.open(file.link)}
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 24 27"
                              fill="none"
                            >
                              <path
                                d="M22 12.2609C22 12.2609 19 18.2609 12 18.2609C5 18.2609 2 12.2609 2 12.2609C2 12.2609 5 6.26086 12 6.26086C19 6.26086 22 12.2609 22 12.2609Z"
                                stroke="#48722D"
                                strokeWidth="2"
                                strokeLinecap="round"
                              />
                              <circle
                                cx="12"
                                cy="12.2609"
                                r="3"
                                stroke="#48722D"
                                strokeWidth="2"
                                strokeLinecap="round"
                              />
                            </svg>
                          </div>
                        </div>
                      );
                    });
                  })}
              </Form.Group>

              <Form.Group className="form-group">
                <Form.Label className="Form-labels">
                  {t(translationConstants.documentNo)}:
                </Form.Label>
                {userDocuments && (
                  <div
                    key={userDocuments[0]?.files[0].documentId}
                    className="expiryDateDisplay"
                  >
                    <p className="text-ellipsis pe-2">
                      {userDocuments[0]?.files[0]?.documentNumber || ""}
                    </p>
                  </div>
                )}
              </Form.Group>
            </div>

            <div className="inputRow">
              <Form.Group className="form-group">
                <Form.Label className="Form-labels">
                  {appendMandatorySignAndTimezoneText(
                    t(translationConstants.expiryData),
                    t,
                    false
                  )}
                </Form.Label>
                {userDocuments && (
                  <div
                    key={userDocuments[0]?.files[0].documentId}
                    className="expiryDateDisplay"
                  >
                    <p>
                      {userDocuments[0]?.files[0]?.expiredOnString
                        ? serverFormatToDateString(
                            userDocuments[0]?.files[0]?.expiredOnString,
                            timezoneConstants.dayMonthYearFormat
                          )
                        : t(translationConstants.NO_EXPIRY_DATE)}
                    </p>
                  </div>
                )}
              </Form.Group>
            </div>
          </Tab>
        )}

        {userCertificates?.length > 0 && (
          <Tab
            eventKey="Certificates"
            title={t(translationConstants.QUALIFICATIONS)}
          >
            <AdminCertificateView
              isViewCertificatesOnly={false}
              certificates={userCertificates}
              approveRejectHandler={HandleModal}
            />
          </Tab>
        )}
      </Tabs>
    </div>
  );
};

export default ViewUserApproval;
